document.addEventListener("DOMContentLoaded", function () {
    function initAutoSlider(selector, reverse = false) {
        const swiperWrapper = document.querySelector(`${selector} .swiper-wrapper`);
        const slide = swiperWrapper?.querySelector(".swiper-slide");
        if (slide) {
            for (let i = 0; i < 10; i++) {
                swiperWrapper.appendChild(slide.cloneNode(true));
            }
        }
        const continuosSlider = new Swiper(selector, {
            slidesPerView: "auto",
            spaceBetween: 30,
            breakpoints: {
                1025: {
                    spaceBetween: 30,
                },
                769: {
                    spaceBetween: 20,
                },
                576: {
                    spaceBetween: 15,
                },
            },
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 30000,
            reverseDirection: reverse,
        });
    }
    initAutoSlider(".qualitySliderLeft", false);
    initAutoSlider(".qualitySliderRight", true);
});


// const productSlider = new Swiper(".prodCardSlider", {
//     slidesPerView: 4,
//     spaceBetween: 30,
//     effect: "slide",
//     speed: "1000",
//     loop: true,
//     breakpoints: {
//         1025: {
//             slidesPerView: 4,
//             spaceBetween: 30,
//         },
//         769: {
//             slidesPerView: 3,
//             spaceBetween: 20,
//         },
//         576: {
//             slidesPerView: 2.3,
//             spaceBetween: 15,
//         },290: {
//             slidesPerView: 1.3,
//             spaceBetween: 12,
//         },
//     },
//     navigation: {
//         nextEl: ".prodnextslide",
//         prevEl: ".prodprevslide",
//     },
// });

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".prodCardSlider").forEach((slider) => {

        const wrapper = slider.querySelector(".swiper-wrapper");
        const originalSlides = slider.querySelectorAll(".swiper-slide");


        const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
        for (let i = 0; i < clones; i++) {
            originalSlides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
        }

        const swiper = new Swiper(slider, {
            slidesPerView: 4,
            spaceBetween: 10,
            loop: true,
            speed: 1000,
            breakpoints: {
        1025: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        769: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        576: {
            slidesPerView: 2.3,
            spaceBetween: 15,
        },290: {
            slidesPerView: 1.3,
            spaceBetween: 12,
        },
    },
            navigation: {
        nextEl: ".prodnextslide",
        prevEl: ".prodprevslide",
    },
        });

    });
});

const testiMonialSlider = new Swiper(".testiMonialSlider", {
    slidesPerView: 2,
    spaceBetween: 30,
    effect: "slide",
    speed: "1000",
    breakpoints: {
        1025: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        769: {
            slidesPerView: 3,
            spaceBetween: 20,
        }, 576: {
            slidesPerView: 2.3,
            spaceBetween: 15,
        },290: {
            slidesPerView: 1.2,
            spaceBetween: 12,
        },
    },
    navigation: {
        nextEl: ".testinextslide",
        prevEl: ".testiprevslide",
    },
});